<template lang="pug">
  section.hero.is-bold.app-navbar
    .delegaciones-mostrar(v-if="estoySiendoReemplazado || estoyReemplazando")
      delegaciones-mostrar-reemplazo
    .hero-head
      nav.nav
        .nav-left
        .nav-center
          a.nav-item.hero-brand(href='/')
            img(src='/static/logo.png', :alt='empresa_full')
        .nav-right.is-flex
          a.nav-item(@click='logout') Salir
    transition(name="fade")
      .modal(v-if="showLogOutModal")
        .modal-content
          .modal-header
            h4.modal-title Cerrando sesión &nbsp;
              i.fa.fa-spinner.fa-spin

</template>

<script>
  import DelegacionesMostrarReemplazo from './c_delegaciones_mostrar_reemplazo';
  export default {
    name: 'topbar',
    components: {
      DelegacionesMostrarReemplazo
    },
    data () {
      return {
        sidebar: {
          opened: true,
          hidden: false
        },
        empresa: process.env.EMPRESA,
        empresa_full: process.env.EMPRESA_FULL,
        showLogOutModal: false
      }
    },
    computed: {
      estoySiendoReemplazado () {
        return this.$store.getters.estoySiendoReemplazado
      },
      estoyReemplazando () {
        return this.$store.getters.estoyReemplazando
      }
    },
    methods: {
      logout () {
        this.showLogOutModal = true
        setTimeout(() => {
          localStorage.setItem('token', '')
          localStorage.setItem('perfilVacaciones', '')
          window.location.href = '/'
        }, 300);
      },
      test () {
        var obj = {
          params: {
            token: localStorage.getItem('token')
          }
        }
        this.axios.get('/test', obj).then((response) => {
          var data = response.data
          data.status = +data.status | 0;
          if (data.status === -1) {
            // No se ha logueado
            alert('No esta logueado')
            localStorage.setItem('token', '')
            window.location.href = '/'
          } else if (data.status === 0) {
            // Algun error de usuario
            alert('error')
          } else {
            // Success
            alert('exito');
          }
        }).catch((error) => {
          console.error('Error:', error)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  $yellow = #ffdd57
  $blue = #2366d1

  .app-navbar {
    z-index 1024
    margin-bottom 10px
    position: fixed;
    min-width: 100%;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

    .nav-right {
      align-items: stretch;
      align-items: stretch;
      flex: 1;
      justify-content: flex-end;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
    }
    .modal {
      display: flex;
      position: fixed;
      justify-content: center
      align-items: center
      z-index: 99;
      left: 0;
      top: 0;
      width: 100vw
      height: 100vh
      overflow: auto;
      background-color: rgba(0, 0, 0, 0.4);
    }

    .modal-content {
      color: #fefefe;
      overflow: hidden;
    }

    .modal-header h4 {
      margin-top: 0;
    }

    .loading {
      border: 16px solid #f3f3f3;
      border-top: 16px solid #3498db;
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
      margin: auto;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  .delegaciones-mostrar
    position fixed
    top 8px
    left 3px
    z-index 11
</style>



// WEBPACK FOOTER //
// Header_Logged.vue?453db995